import { Root } from '@radix-ui/react-avatar'
import { cn } from '@seen/ui'
import { cva, type VariantProps } from 'class-variance-authority'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

const variants = cva('relative flex shrink-0 overflow-hidden rounded-full', {
  variants: {
    size: {
      default: 'size-10',
      icon: 'size-5 text-3xs',
      7: 'size-7 text-2xs',
      6: 'size-6 text-2xs',
      3.5: 'size-3.5 text-4xs',
      3: 'size-3 text-4xs',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

interface AvatarRootProps
  extends
    ComponentPropsWithoutRef<typeof Root>,
    VariantProps<typeof variants> {}

export const AvatarRoot = forwardRef<ElementRef<typeof Root>, AvatarRootProps>(
  ({ className, size, ...props }, ref) => (
    <Root ref={ref} className={cn(variants({ size, className }))} {...props} />
  )
)
AvatarRoot.displayName = Root.displayName
